import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  public addonBuySuccessfully: BehaviorSubject<any> = new BehaviorSubject(null);
  public addonBuyError: BehaviorSubject<any> = new BehaviorSubject(null);
  public subscribeLogin: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentAccount: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public generalNotification: BehaviorSubject<any> = new BehaviorSubject(null);
  public account: BehaviorSubject<any> = new BehaviorSubject(null);
  public sku: BehaviorSubject<any> = new BehaviorSubject(null);
  public skuDetails: BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedFilter: BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedSort: BehaviorSubject<any> = new BehaviorSubject(null);
  public filteredData:BehaviorSubject<any> = new BehaviorSubject(null);
  public filteredItemsData:BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedAccount:BehaviorSubject<any> = new BehaviorSubject(null);
  public resetFilter:BehaviorSubject<any> = new BehaviorSubject(null);
  public resetVerification:BehaviorSubject<any> = new BehaviorSubject(null);
  public plantATreeAccountDetails:BehaviorSubject<any> = new BehaviorSubject(null);
constructor() { }

}
